import { render, staticRenderFns } from "./registre-nfs.html?vue&type=template&id=5c108662&scoped=true&external"
import script from "./registre-nfs.js?vue&type=script&lang=js&external"
export * from "./registre-nfs.js?vue&type=script&lang=js&external"
import style0 from "./registre-nfs.scss?vue&type=style&index=0&id=5c108662&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c108662",
  null
  
)

export default component.exports